export default "__VITE_ASSET__BntPuYTK__"